// extracted by mini-css-extract-plugin
export default {"underLine":"ProductListTableV8_underLine__3vgPu"};